export const bankCards = {
    paymentAccountCard: {
        entity: 'paymentAccount',
        path: 'paymentAccount',
        titleBar: { mergeParams: ['accountName'], new: 'bank.account.form.new.title' },
        cardTitle: {
            title: 'bank.account.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'bank.account.form.actions.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'import',
                    label: 'bank.account.form.actions.import',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        width: '1024px',
        sections: [
            {
                id: 'paymentAccount',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'paymentAccountTypeBankId',
                        fields: [
                            {
                                type: 'select',
                                id: 'paymentAccountTypeId',
                                displayField: 'paymentAccountTypeName',
                                label: 'bank.account.form.type',
                                placeholder: 'bank.account.form.type.placeholder',
                                entity: 'paymentAccountType',
                                valueMap: {
                                    'paymentAccountTypeName': 'name',
                                    'paymentAccountTypeId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            },
                            {
                                type: 'select',
                                id: 'bankId',
                                displayField: 'bankName',
                                label: 'bank.account.form.bank',
                                placeholder: 'bank.account.form.type.placeholder',
                                entity: 'bank',
                                valueMap: {
                                    'bankName': 'name',
                                    'bankId': 'id',
                                    'bankLogoPath': 'logoPath'
                                },
                                options: { withHeaders: true, autoSelectFirst: false },
                                required: false,
                                condition: { field: 'paymentAccountTypeId', operator: 'equals', value: 'bank' },
                                collapse: false
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'accountNameHolder',
                        fields: [
                            {
                                type: 'text',
                                id: 'accountName',
                                label: 'bank.account.form.name',
                                placeholder: 'bank.account.form.name.placeholder',
                                required: true
                            },
                            {
                                type: 'text',
                                id: 'accountHolder',
                                label: 'bank.account.form.holder',
                                placeholder: 'bank.account.form.holder.placeholder',
                                required: false
                            },
                        ]
                    },


                    {
                        type: 'group',
                        id: 'bankCountryIdCurrency',
                        fields: [
                            {
                                type: 'country',
                                id: 'bankCountryId',
                                displayField: 'bankCountryName',
                                label: 'bank.account.form.country',
                                valueMap: {
                                    'bankCountryId': 'id',
                                    'bankCountryName': 'name',
                                },
                                required: true,
                                defaultType: 'country'
                            },
                            {
                                type: 'select',
                                id: 'currency',
                                displayField: 'currencyName',
                                label: 'bank.account.form.currency',
                                placeholder: 'bank.account.form.currency.placeholder',
                                entity: 'currency',
                                valueMap: {
                                    'currency': 'id',
                                    'currencyName': 'name'
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                            },

                        ]
                    },
                    /*
                     * The GL account this account's payments post to. It is
                     * filled in automatically when the account is created — see
                     * linkBankGlAccount — but it is a plain picker, because the
                     * chart is the org's and the automatic choice is only a
                     * starting point. Postable accounts only: a heading or a sum
                     * line cannot carry a posting.
                     *
                     * Left empty — created before the org had a chart, unlinked
                     * when the chart was replaced, or cleared — it is never filled
                     * in behind the user's back. The pill offers the same choice
                     * creation would have made (fieldResolvers/bankGlAccount),
                     * claiming a free bank account in the chart or creating the
                     * next one, and the user's save stores it.
                     */
                    {
                        type: 'connect',
                        id: 'glAccountId',
                        displayField: 'glAccountIdName',
                        label: 'bank.account.form.glAccount',
                        placeholder: 'bank.account.form.glAccount.placeholder',
                        modalTitle: 'bank.account.form.glAccount.modal.title',
                        entity: 'glAccount',
                        entityParams: {
                            type: 'filter',
                            filters: [
                                { key: 'isPostable', value: 'true' },
                                { key: 'active', value: 'true' }
                            ]
                        },
                        valueMap: {
                            'glAccountId': 'id',
                            'glAccountIdName': 'name'
                        },
                        options: { withHeaders: false },
                        emptyActions: [
                            {
                                id: 'createGlAccount',
                                label: 'bank.account.form.glAccount.create',
                                resolver: 'bankGlAccount',
                                params: ['id', 'accountName', 'currency']
                            }
                        ]
                    },
                    {
                        type: 'text-readOnly',
                        id: 'balance',
                        label: 'bank.account.form.balance',
                        displayType: 'quantity'
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'paymentAccountCard.paymentAccount.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'accountName',
                    emptyMessage: 'bank.account.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'accountName',
                                    scale: 'title'
                                },
                                {
                                    type: 'image',
                                    value: 'bankLogoPath',
                                    scale: 'other',
                                    width: '8rem',
                                    height: '4rem'
                                }
                            ],
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'balance',
                                    scale: 'title',
                                    decorator: 'currency',
                                    displayType: 'amount'
                                },
                                {
                                    type: 'merge',
                                    value: '${1}',
                                    mergeParams: ['bankCountryName'],
                                    scale: 'normal'
                                },

                            ]
                        }
                    ]

                }
            },
        ]
    },

    paymentTransactionCard: {
        entity: 'paymentTransaction',
        path: 'paymentAccount/:id/paymentTransaction',
        titleBar: { mergeParams: ['title'], new: 'bank.account.transaction.form.new.title' },
        cardTitle: {
            title: 'contact.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.form.button.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        fieldsLogic: ['date', 'currency', 'amount'],
        sections: [
            {
                id: 'paymentInteraction',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'date',
                        id: 'date',
                        label: 'bank.account.transaction.form.date',
                        placeholder: 'bank.account.transaction.form.date.placeholder',
                        defaultType: 'date',
                        // Editable on create; a formatted read-only date afterwards.
                        // The recalculation links only matter while it is editable.
                        condition: { field: '$mode', operator: 'in', value: ['new', 'edit'] },
                        conditionals: [
                            {
                                condition: { field: '$mode', operator: 'equals', value: 'edit' },
                                set: { type: 'text-readOnly', displayType: 'date' },
                                unset: ['linkedFields']
                            }
                        ],
                        linkedFields: ['amount', 'date', 'currency', 'exchangeRate']
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'bank.account.transaction.form.description',
                        placeholder: 'bank.account.transaction.form.description.placeholder',
                        required: true,
                        // A textarea while editable, a read-only block afterwards. The
                        // read-only view is one row taller.
                        condition: { field: '$mode', operator: 'in', value: ['new', 'edit'] },
                        conditionals: [
                            {
                                condition: { field: '$mode', operator: 'equals', value: 'edit' },
                                set: { type: 'text-readOnly', rows: 4 }
                            }
                        ],
                        rows: 3
                    },
                    {
                        type: 'group',
                        id: 'amountCurrencyNew',
                        condition: { field: '$mode', operator: 'equals', value: 'new' },
                        fields: [
                            {
                                type: 'number',
                                id: 'amount',
                                label: 'bank.account.transaction.form.amount',
                                placeholder: 'bank.account.transaction.form.title.placeholder',
                                required: true,
                                decimals: 2,
                                defaultType: 'value',
                                defaultValue: 1,
                                condition: { field: '$mode', operator: 'equals', value: 'new' },
                                linkedFields: ['amount', 'date', 'currency', 'exchangeRate'],
                                variant: 'amount'
                            },
                            {
                                type: "text-readOnly",
                                id: 'currency',
                                displayField: 'currency',
                                parameter: "date",
                                label: 'bank.account.transaction.form.currency',
                                condition: { field: '$mode', operator: 'equals', value: 'new' },
                                linkedFields: ['amount', 'date', 'currency', 'exchangeRate']
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'amountCurrencyEdit',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'amount',
                                label: 'bank.account.transaction.form.amount',
                                placeholder: 'bank.account.transaction.form.title.placeholder',
                                condition: { field: '$mode', operator: 'equals', value: 'edit' },
                                displayType: 'amount'
                            },
                            {
                                type: "text-readOnly",
                                id: 'currency',
                                displayField: 'currency',
                                parameter: "date",
                                label: 'bank.account.transaction.form.currency',
                                condition: { field: '$mode', operator: 'equals', value: 'edit' }
                            }]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'paymentTransactionCard.paymentInteraction.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'title',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'title',
                                    scale: 'title'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }]
    },
}
